import {PayoutMethods} from '../modules/react-sell-ticket-add-payout-method/config';

export const PAYOUT_METHODS = {
  PAYPAL: 'paypal',
  DIRECT_DEPOSIT: 'direct_deposit'
};

export const PAYOUT_METHODS_MAP = {
  [PayoutMethods.PAY_PAL]: PAYOUT_METHODS.PAYPAL,
  [PayoutMethods.DIRECT_DEPOSIT] : PAYOUT_METHODS.DIRECT_DEPOSIT
};
